module.exports = __webpack_public_path__ + "static/media/Avatars_Male-01.9a7f4574.png";